var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010101","fillRule":"evenodd","d":"M45.5,33 C45.8899985,33 46.2799971,33.1479917 46.5775741,33.4449888 L55.5536345,42.4045698 C56.1487885,42.998564 56.1487885,43.9615238 55.5536345,44.5545044 C54.9584804,45.1484985 53.9946559,45.1484985 53.3995019,44.5545044 L45.5,36.6703974 L37.6004981,44.5545044 C37.0053441,45.1484985 36.0415196,45.1484985 35.4463655,44.5545044 C34.8512115,43.9615238 34.8512115,42.998564 35.4463655,42.4045698 L44.4224259,33.4449888 C44.7200029,33.1479917 45.1100015,33 45.5,33","transform":"matrix(1 0 0 -1 -35 45)"}));
}

Arrow.defaultProps = {"width":"21","height":"12","viewBox":"0 0 21 12"};

module.exports = Arrow;

Arrow.default = Arrow;
